export default __webpack_public_path__ + "static/media/davletbaev.23e38f91.jpg";